<template>
  <div class="content-wrapper bg-white dark:bg-darkblue-900 flex flex-col w-full relative overflow-hidden">
    <slot name="header" />
    <article class="content flex flex-col flex-auto overflow-y-auto w-full h-full">
      <div class="w-full md:w-11.5/12 h-full flex justify-center content-center">
        <div class="px-4 lg:px-10 flex justify-center items-center">
            <slot name="main" />
        </div>
      </div>
    </article>
    <slot name="layout-extend" />
  </div>
</template>

<script>
export default {
  name: 'layout-detail-full-width'
}
</script>
